<template><BusinessPage module-key="users" /></template>
<script>import BusinessPage from '../common/BusinessPage.vue'; export default { name: 'UsersPage', components: { BusinessPage } }</script>
